export const promotion =
    `
    <span class="tip">《商铺助手推广服务协议》(以下简称“本协议”)是商铺助手用户与商铺助手运营者之间的法律协议。</span>
    <h2>本协议是用户注册账号并充值支付，使用商铺助手推广服务时适用的通用条款。因此，请您在注册商铺助手账号并充值支付或接受商铺助手提供的相关服务之前，详细地阅读本协议的所有内容(尤其是以粗体或下划线标识的条款，因为这些条款可能会明确您应履行的义务或对您的权利有所限制)。商铺助手推广用户需要了解并同意以下条款所述事项才能完成充值支付，享受商铺助手提供的推广服务。无论您事实上是否认真阅读,只要您勾选同意或点击确认本协议，或者实际接受了商铺助手的相关推广服务,就表示您已接受了本协议。如果发生纠纷，您不能以未仔细阅读为由进行抗辩。</h2>
    <h1 align="center">一、定义</h1>
    <p>1.1商铺助手推广用户:指符合本协议规定的条件并已通过代理商或直接向其商铺助手的服务账户中充值或向商铺助手支付服务费用，使用商铺助手服务账号登陆商铺助手自行编辑、发布、展示推广信息(由文字、图片、链接、页面等组成的推广物料)并有权随时更新、修改后重新发布的单位或个人，本协议中也称“您”或“甲方”或“用户”。</p>
    <p>1.2商铺助手平台(或商铺助手):指武汉千城万铺网络科技有限公司运营的商铺助手微信公众号，武汉千城万铺网络科技有限公司在本协议中也称“本公司”或“乙方”</p>
    <p>1.3推广服务:指按照商铺助手的指定方式支付一-定服务费用之后，用户可以享有特权等服务，简称为:本服务。</p>
    <p>1.4置顶:推广服务中的置顶功能，是指将发布的店铺转让信息优先排序于未开通此功能的店铺转让信息之前，但并非指置顶所有店铺转让信息或者开通此功能店铺转让信息之前</p>
    <p>1.5终身有效:享受的推广服务截止店铺转让信息在平台下架之前一直有效。
    <h1 align="center">二、本协议的组成、变更及生效</h1>
    <p>2.1商铺助手微信公众号及用户后台发布的推广服务相关的各服务协议、服务条款、操作规则、审核规则、帮助、名词解释等(本协议中统称“规则”)为本协议的有效组成部分，商铺助手按照本协议、推广服务相关的各项规则为广大用户提供商铺助手推广服务。本协议未涉及的事项依照《商铺助手使用协议》处理。</p>
    <p>2.2您确认商铺助手将有权对您提交的资质和相关内容进行审核，您了解并同意，如您提交的资质虚假或者您的推广内容违反国家法律法规的相关规定或者违反商铺助手的审核规则，商铺助手将有权拒绝为您提供服务。</p>
    <p>2.3根据国家法律法规变化及商铺助手运营需要，商铺助手有权对本协议条款及相关规则不时地进行修改,修改后的内容一旦以任何形式公布在商铺助手.上即生效，并取代此前相关内容,您应不时关注商铺助手微信公众号公告、提示信息及协议、规则等相关内容的变动。您知悉并确认，如您不同意更新后的内容，应立即停止使用商铺助手微信公众号;如您继续使用，即视为知悉变动内容并同意接受。如发生有关争议时，即视为知悉变动内容并同意接受。如发生有关争议时，以最新的《商铺助手推广用户服务协议》为准。</p>
    <h1 align="center">三、服务说明</h1>
    <p>商铺助手可能会根据不同的产品及服务类型，推出不同的推广服务类型，目前，商铺助手提供首页置顶、智能匹配、意向追踪、等不同种类的推广服务。同时商铺助手平台也可能会根据用户的需求、产品及服务类型的变化等,对现有推广服务种类进行调整以及不断推出新的推广服务种类。具体推广服务种类及服务内容及费用标准以相关服务页面公布、实际提供的内容为准。用户可以自行根据需要选择相应服务。用户可通过登录商铺助手，免费查询其消费的服务的详情</p>
    <h1 align="center">四、收费标准及服务开通</h1>
    <p>4.1.收费标准
    <p>4.1.1本服务是商铺助手平台提供的推广服务,用户须在按照本服务的收费标准支付相应费用后，方可使用本服务。
    <p>4.1.2收费费用标准:服务费用的具体资费政策以商铺助手软件内届时公布的内容为准，商铺助手有权随时修改本服务的资费政策(包括但不限于服务价格)、订购方式，并在商铺助手软件内予以公布。如用户不同意按照届时商铺助手制定(修改)并公布的资费政策(包括但不限于服务价格)支付服务费用或不同意按照届时商铺助手制定(修改)并公布的订购方式订购本服务，用户将不能获得本服务任何部分或全部,如已获得本服务用户应自行主动取消本服务,但商铺助手有权不予退还用户已支付的任何服务费用。但用户已经付费取得的服务内容、服务时长等，可以在原有范围内使用，如因服务内容变更导致无法继续使用的，用户可以申请退还未使用部分的费用。</p>
    <p>4.2.服务开通</p>
    <p>4.2.1重要约定:用户通过微信支付方式购买商铺助手付费服务。用户充值一旦成功，充值即确定完成，商铺助手将不提供任何更改、修正服务。用户不得向商铺助手要求退还充值金额，除非所充入金额本身无法使用到任何应用内容中，若发生异议用户可通过客服专线查询处理。</p>
    <p>4.2.2非经商铺助手许可，用户不得以以下方式开通服务。</p>
    <p>(1)以营利、经营等非个人使用的目的为自己或他人开通本服务;</p>
    <p>(2)通过任何机器人软件、蜘蛛软件、爬虫软件、刷屏软件等任何程序、软件方式为自己或他人开通本服务;</p>
    <p>(3)通过任何不正当手段或以违反诚实信用原则的方式为自己或他人开通本服务;</p>
    <p>(4)通过非商铺助手指定的方式为自己或他人开通本服务;</p>
    <p>(5)通过侵犯商铺助手或他人合法权益的方式为自己或他人开通本服务，如通过第三方平台由他人代充代付;</p>
    <p>(6)通过其他违反相关法律、行政法规、国家政策等的方式为自己或他人开通本服务。</p>
    <p>4.3.服务期限</p>
    <p>本服务中相关服务可能存在相关期限，如有期限限制以用户自行选择并支付相应服务费用的期限为准。</p>
    <p>4.4风险提示</p>
    <p>若用户以非法的方式，或使用非商铺助手所指定的充值方式进行充值，商铺助手不保证该充值顺利或者正确完成。若因此造成用户权益受损时，商铺助手不会作任何补偿或赔偿,商铺助手同时保留随时冻结或终止该用户帐号资格及使用各项充值服务的权利。</p>
    <h1 align="center">五、用户权利及义务</h1>
    <p>5.1重要约定:用户不得通过未经商铺助手授权许可的任何第三方平台或渠道购买商铺助手提供的推广服务或产品;不得将账号提供给第三方进行代充代付等活动。因违反前述约定导致用户隐私泄露的，用户应当自行承担相应后果;如给商铺助手造成损失的，商铺助手可以要求用户承担违约责任并赔偿损失。</p>
    <p>5.2用户同意不会采用收费或免费的方式，全部或部分地在任何公开场合展示用户购买的推广服务内容，除非用户的.上述行为不会构成侵权。</p>
    <p>5.3用户在使用本服务时不得利用本服务从事以下行为，包括但不限于:</p>
    <p>(1)发布、传送、传播、储存违反国家法律、危害国家安全统一、社会稳定、公序良俗、社会公德以及侮辱、诽谤、淫秽、暴力的内容;</p>
    <p>(2)发布、传送、传播、储存侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的内容;</p>
    <p>(3)虚构事实、隐瞒真相以误导、欺骗他人;</p>
    <p>(4)发表、传送、传播广告信息及垃圾信息;</p>
    <p>(5)从事其他违反法律法规、政策及公序良俗、社会公德等的行为。</p>
    <p>(6)通过任何方式搜集本服务中其他用户的用户名、电子邮件等相关信息，并以发送垃圾邮件、连锁邮件、垃圾短.信、即时消息等方式干扰、骚扰其他用户;</p>
    <p>(7)通过本服务发布包含广告、宣传、促销等内容的信息。</p>
    <p>5.4对自己行为负责</p>
    <p>用户充分了解并同意，用户必须为自己注册帐号下的一切行为负责，包括但不限于用户所发表的任何内容以及由此产生的任何后果。用户应对本服务中的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内突的正确术与依赖而产生的区偿。</p>
    <p>5.5用户应自行负责妥善且正确地保管、使用、维护其在商铺助手申请取得的账户及账户密码。用户应对其账户密码采取必要和有效的保密措施。非商铺助手原因致使用户账户密码泄漏以及因用户保管、使用、维护不当造成损失的，商铺助手无须承担与此有关的任何</p>
    <p>责任。</p>
    <p>5.6用户明确了解并同意，本协议第4.2条款约定的付费方式为代收费运营商托收的付款方式，用户通过此种付费方式付费可能存在一-定的商业风险(包括但不限于不法分子利用用户账户或银行卡等有价卡等进行违法活动)，该等风险均会给用户造成相应的经济损失。为此，用户同意商铺助手在充分履行其在本协议项下全部义务及勤勉谨慎义务的前提下不对用户的前述风险和损失承担任何责任;并且商铺助手不承担向不法分子追究侵权责任或者代其向用户承担损失的任何责任和义务。</p>
<h1 align="center">六、用户数据的使用及保护</h1>
<p>6.1为了履行本协议，乙方会在商铺助手的服务器.上保留甲方的信息，包括但不限于注册信息、消费信息、推广内容等。甲方同意商铺助手基于系统升级、测试、更新等目的使用甲方的信息。</p>
<p>6.2用户理解并同意商铺助手可能会基于法律法规的相关规定向相应的司法或者行政机关提供用户的相关数据信息。</p>
<h1 align="center">七、免责声明</h1>
<p>7.1甲方了解并同意:</p>
<p>乙方对下列情形不承担任何责任:</p>
<p>(a)并非由于乙方的故意或过失而导致商铺助手推广服务未能注册成功;.</p>
<p>(b)由于甲方或与其签约的代理商的故意或过失导致甲方遭受损失的，代理商造成甲方损失的甲方知悉应向代理商自行追索相关法律责任;</p>
<p>(c)由于乙方对商铺助手推广服务系统进行系统测试、升级、更新、服务抽样测试，对甲方产生的任何影响。</p>
<p>7.2乙方对由于政府行为譬如政策或法规的变更、自然灾害或战争、通讯线路中断、黑客攻击、计算机病毒侵入或发作、电信部门技术调整、因政府管制而造成微信公众号的暂时性关闭等任何影响网络正常运营的不可抗力事件，以及他人蓄意破坏、正常的系统维护、系统升</p>
<p>级，或者因网络拥塞而导致本微信公众号不能访问而造成的本微信公众号所提供的信息及数据的延误、停滞或错误，以及使用者由此受到的一-切损失不承担任何责任。</p>
<p>7.3商铺助手推广服务不能保证以下事项:</p>
<p>(1)商铺助手推广服务上发布的推广服务相关信息的正确性、准确性、可靠性、及时性或其他方面不进行保证。</p>
<p>(2)商铺助手不对推广服务效果承担任何保证责任，推广效果主要基于推广产品的质量及用户体验等因素，故商铺助手无需对推广效果负责，推广效果亦不可作为影响本协议执行及各方履行合同义务的因素或理由。</p>
<p>(3)商铺助手推广服务不能保证网络服务一定能满足用户的要求，也不担保网络服务不会中断，对网络服务的及时性、安全性、准确性也都不作担保。</p>
<p>(4)商铺助手推广服务不保证能够长期无错误运营,也不保证服务器不受病毒或其他故障的侵扰。</p>
<p>(5)商铺助手对“赠送”、“送”的免费服务或权益丕做保证，用户不得以未到达心理预期对此提出已经达到现状效果之外的其它要求。举例:如购买首页置顶服务赠送刷新，平台提供但用户不能对使用该赠送服务要求达到效果</p>
<h1 align="center">八、损害赔偿</h1>
<p>8.1甲方违反法律法规、乙方平台规则及本协议任一条款约定的，乙方有权冻结甲方在商铺助手的服务账号、终止为甲方提供服务、扣除甲方尚未消耗完毕的全部服务费用作为违约金并补偿商铺助手网络服务提供者由此所遭受的相关损失(包括第三方处罚/索赔/争议
    解决、甲方已额外享有的推广服务成本(包括但不限于推广.优惠等)。同时乙方有权依据法律法规向有关监管机关举报/披露甲方的违法失信行为。</p>
<p>8.2在甲方无违法违约行为的前提下，乙方未按照本协议约定为甲方提供网络推广服务的，甲方有权要求乙方以补投放、相应顺延服务时长、补足等额推广服务等方式之-补偿;如乙方提前解约的，乙方需将甲方尚未消耗完毕的款项(但同时(额外)享有/赠送的产品服务乙方有
权不予折现/退还)退还给甲方。.</p>
<p>8.3甲方在投诉其他用户有违法行为或违反本协议情形时,投诉者应承担不实投诉所产生的全部法律责任。如侵犯他人的合法权益，投诉人应独立承担全部法律责任。</p>
<h1 align="center">九、法律适用和争议解决</h1>
<p>9.1本协议之订立、生效、解释、修订、补充、终止、执行和争议解决均适用中华人民共和国法律。如法律无相关规定的，则应参照通用国际商业惯例和(或)行业惯例。</p>
<p>9.2如本协议条款与国家法律相抵触时,则这些条款将完全按法律规定重新解释，其它条款则依旧保持对双方产生法律效力和影响。</p>
<p>9.3因本协议产生之争议、纠纷，应由商铺助手与您友好协商;协商不成的，应依照中华人民共和国法律予以处理，并以湖北省武汉市洪山区区人民法院为第一审管辖法院;按照中华人民共和国法律，因级别管辖的规定，湖北省武汉市洪山区区人民法院无权管辖的，以其.上级法院作为第一审管辖</p>

    `